$(document).ready(_ => {
    $('.message').each((index, el) => {
        const id = $(el).data('id');
        const editForm = $(el).find('form.edit-form[data-id=edit' + id + ']');
        const replyToForm = $(el).find('form.edit-form[data-id=replyTo' + id + ']');
        const message = $(el).find('.message-content[data-id=' + id + ']');

        $(el).find('button.edit-button[data-id=' + id + ']').click(_ => {
            editForm.show();
            message.hide();
        });

        $(el).find('button.reply-button[data-id=' + id + ']').click(_ => {
            replyToForm.show();
        });

        $(el).find('button.cancel-button').click(_ => {
            editForm.hide();
            replyToForm.hide();
            message.show();
        });
    });

    $('input[name=originalImage]').on('change', _ => {
        $('.image-preview').hide();
    })
});
